import { request } from './client';
import type { DeviceApproveInput, DeviceRow, SyncReviewRow, DeviceRegisterInput, LanEventRow } from '@kassa/shared';

// Cihazlar (KT-79): təsdiq, ləğv, yoxlanmalı internetsiz satışlar. İcazə: settings.devices.
export const devicesApi = {
  devices: () => request<DeviceRow[]>('GET', '/api/devices'),
  deviceRegister: (input: DeviceRegisterInput) => request<DeviceRow>('POST', '/api/devices/register', input),
  deviceApprove: (id: string, input: DeviceApproveInput) => request<DeviceRow>('POST', `/api/devices/${encodeURIComponent(id)}/approve`, input),
  deviceRevoke: (id: string) => request<DeviceRow>('POST', `/api/devices/${encodeURIComponent(id)}/revoke`),
  deviceLanEvents: () => request<LanEventRow[]>('GET', '/api/devices/lan-events'),
  deviceReviews: () => request<SyncReviewRow[]>('GET', '/api/devices/reviews'),
};
